<template>
  <footer class="relative mt-[10px] tablet:mt-0 laptop:mt-[40px] largeDesktop:mt-0 overflow-hidden
         before:content-['']
         before:absolute before:inset-0
         before:bg-[url('@/assets/images/footer-bg.svg')]
         before:bg-top before:bg-cover mobile:before:h-[160px] laptop:before:h-[170px] largeDesktop:before:h-[240px] before:bottom-0 before:top-auto
         before:z-0" :class="$route.path == '/thankyou' ? '!absolute bottom-0 left-0 w-full' : ''"
    v-if="$route.path != '/dashboard'">
    <div class="relative !flex items-end sm:items-center justify-center tablet:gap-[10px] laptop:gap-[15px] z-1 ">
      <div>
        <img src="../../../assets/images/man-image.png" alt="img"
          class="mobile:h-[200px] tablet:h-[215px] laptop:h-[210px] largeDesktop:h-[290px] object-cover">
      </div>
      <div
        class="flex flex-col mobile:gap-[10px] desktop:gap-[10px] largeDesktop:gap-[15px] pb-2.5 mobile:pb-0 mobile:!mt-[15px] mobile:!mb-[5px] tablet:!mb-0 tablet:!mt-[60px] largeDesktop:!mt-[50px]">
        <img src="../../../assets/images/myHappyHomeLogo.svg" alt=""
          class="mobile:w-[120px] mobile:h-[50px] largeDesktop:w-[180px] largeDesktop:h-[70px] object-contain">
          <div class="flex gap-2.5">
            <a href="/contact-us"
              class="CustomYellowBtn w-max font-poppins text-[14px] laptop:text-[16px] font-medium laptop:font-semibold rounded-full px-[15px] laptop:px-[30px] py-[2px] laptop:py-[7px] cursor-pointer
                !border-[1px] mobile:bg-customYellow-100 laptop:!bg-transparent mobile:!text-[#10284C] laptop:!text-customYellow-100 laptop:hover:!text-black-100">Contact
              Us</a>
            <a @click="faqClicked()"
              class="CustomYellowBtn w-max font-poppins text-[14px] laptop:text-[16px] font-medium laptop:font-semibold rounded-full px-[15px] laptop:px-[30px] py-[2px] laptop:py-[7px] cursor-pointer
                !border-[1px] mobile:bg-customYellow-100 laptop:!bg-transparent mobile:!text-[#10284C] laptop:!text-customYellow-100 laptop:hover:!text-black-100">FAQ</a>
          </div>
        <div>
          <p class="m-0 laptop:mb-2 font-poppins text-[12px] tablet:text-[13px] text-[#fff] text-left">Copyright © {{ currentYear }}
            <span class="text-[#F8B134]">My</span>HappyHome
          </p>
          <span class="flex items-center gap-1 text-white">
            <a @click="termsClicked()"
              class="cursor-pointer text-[11px] sm:text-[12px] underline font-normal font-poppins text-[#F5B134]">Terms and Conditions
            </a>
            - <a @click="privacyClicked()"
              class="cursor-pointer text-[11px] sm:text-[12px] underline font-normal font-poppins text-[#F5B134]"> Privacy Policy</a>
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  // name: "FooterPartial",
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  methods: {

    faqClicked(){
      this.$router.push({
        name: 'faq',
      });
    },
    termsClicked() {
      this.$router.push({
        name: 'termsAndConditions',
      });
    },

    privacyClicked() {
      this.$router.push({
        name: 'privacyPolicy',
      });
    }

  }
};
</script>